import { dcpcApi } from './dcpcApi';
import { tags } from './tags';

const {
  OBSERVATION_TYPES_TAG,
} = tags;

dcpcApi.enhanceEndpoints({ addTagTypes: [OBSERVATION_TYPES_TAG] });
const observationTypesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
   getObservationTypes: builder.query({
     query: () => 'observation-types',
     providesTags: [OBSERVATION_TYPES_TAG],
   }),
  }),
});

export const {
  useGetObservationTypesQuery,
} = observationTypesApi;
